module.exports = __webpack_public_path__ + "img/1488020520.d2710715.jpg";